export default __webpack_public_path__ + "static/media/190629_190332_IMG_3946.db84a11c.jpg";